export default __webpack_public_path__ + "static/media/flagpoints.aded80db.svg";